import { render, staticRenderFns } from "./workGuideIndex.vue?vue&type=template&id=f87ab858&scoped=true&"
import script from "./workGuideIndex.vue?vue&type=script&lang=js&"
export * from "./workGuideIndex.vue?vue&type=script&lang=js&"
import style0 from "./workGuideIndex.vue?vue&type=style&index=0&id=f87ab858&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f87ab858",
  null
  
)

export default component.exports